import { useEffect, useState } from "react";
import { GOOGLE_MAPS_API_KEY } from "src/app.config";

import { COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES } from "@constants/cookies";
import { googleMapAPIURL } from "@constants/urls";
import { getCookie } from "@utils/common.utils";
const useLoadGoogleMaps = (): boolean => {
  const [loaded, setLoaded] = useState<boolean>(!!window.google);
  const cookieConsent = getCookie(COOKIE_CONSENT_KEY);
  useEffect(() => {
    if (cookieConsent === COOKIE_CONSENT_VALUES.ALL) {
      if (window.google) {
        setLoaded(true);
        return;
      }

      const scriptId = "fg-google-maps-script";
      const existingScript = document.getElementById(
        scriptId
      ) as HTMLScriptElement | null;

      if (existingScript) {
        existingScript.addEventListener("load", () => setLoaded(true));
        return;
      }

      const script = document.createElement("script");
      script.id = scriptId;
      script.src = googleMapAPIURL(GOOGLE_MAPS_API_KEY);
      script.async = true;
      script.defer = true;
      script.onload = () => setLoaded(true);
      script.onerror = () => console.error("Failed to load Google Maps API");

      document.head.appendChild(script);

      return () => {
        script.removeEventListener("load", () => setLoaded(true));
      };
    }
  }, [cookieConsent]);

  return loaded;
};

export default useLoadGoogleMaps;
